(function() {
  // ─── PROPERTIES PATCH ───────────────────────────────────────────
  if (window.__propPatchDone) return;
  window.__propPatchDone = true;

  var _cachedProps = {};

  function collectAndCache() {
    _cachedProps = {};
    document.querySelectorAll('[name^="properties["]').forEach(function(el) {
      if (el.type === 'radio' && !el.checked) return;
      if (el.type === 'checkbox' && !el.checked) return;
      var key = el.name.replace(/^properties\[/, '').replace(/\]$/, '');
      if (el.value && el.value.trim()) _cachedProps[key] = el.value.trim();
    });
  }

  document.addEventListener('click', function() {
    collectAndCache();
  }, true);

  function injectIntoFormData(formData) {
    if (Object.keys(_cachedProps).length === 0) return formData;
    Object.keys(_cachedProps).forEach(function(key) {
      if (!formData.has('properties[' + key + ']')) {
        formData.append('properties[' + key + ']', _cachedProps[key]);
      }
    });
    return formData;
  }

  function injectIntoJSON(body) {
    if (Object.keys(_cachedProps).length === 0) return body;
    try {
      var data = JSON.parse(body);
      if (data.id) {
        data.properties = Object.assign({}, _cachedProps, data.properties || {});
      }
      if (data.items) {
        data.items = data.items.map(function(i) {
          i.properties = Object.assign({}, _cachedProps, i.properties || {});
          return i;
        });
      }
      return JSON.stringify(data);
    } catch(e) { return body; }
  }

  var _fetch = window.fetch;
  window.fetch = function(resource, config) {
    var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';

    if (url.includes('/cart/add') && config && config.method && config.method.toUpperCase() === 'POST') {
      if (config.body instanceof FormData) {
        config = Object.assign({}, config, { body: injectIntoFormData(config.body) });
      } else if (typeof config.body === 'string') {
        config = Object.assign({}, config, { body: injectIntoJSON(config.body) });
      }
    }

    var result = _fetch.call(this, resource, config);

    // ─── QUICK VIEW ATC ─────────────────────────────────────────
    if (url.includes('/cart/add')) {
      result.then(function(response) {
        if (response.ok) {
          var qvModal = document.querySelector('xo-modal[xo-name="quick-view"]');
          if (qvModal) qvModal.removeAttribute('xo-open');

          setTimeout(function() {
            if (typeof window.HS_SLIDE_CART_OPEN === 'function') {
              window.HS_SLIDE_CART_OPEN();
            }
          }, 300);
        }
      });
    }

    return result;
  };

  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function(method, url) {
    this._xhrUrl = url;
    this._xhrMethod = method;
    return _open.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function(body) {
    if (this._xhrUrl && this._xhrUrl.includes('/cart/add') && this._xhrMethod && this._xhrMethod.toUpperCase() === 'POST') {
      if (body instanceof FormData) {
        body = injectIntoFormData(body);
      } else if (typeof body === 'string') {
        body = injectIntoJSON(body);
      }
    }
    return _send.call(this, body);
  };
  // ─── KILL THEME CART DRAWER ─────────────────────────────────────
var cartModal = document.querySelector('xo-modal[xo-name="cart"]');
if (cartModal) {
  new MutationObserver(function() {
    if (cartModal.hasAttribute('xo-open')) {
      cartModal.removeAttribute('xo-open');
    }
  }).observe(cartModal, { attributes: true, attributeFilter: ['xo-open'] });
}

// Also observe for late DOM
document.addEventListener('DOMContentLoaded', function() {
  var cartModal = document.querySelector('xo-modal[xo-name="cart"]');
  if (cartModal) {
    new MutationObserver(function() {
      if (cartModal.hasAttribute('xo-open')) {
        cartModal.removeAttribute('xo-open');
      }
    }).observe(cartModal, { attributes: true, attributeFilter: ['xo-open'] });
  }
});

})();

document.addEventListener('DOMContentLoaded', function () {
  const descBlocks = document.querySelectorAll('.xo-product-info-content__description-style-1');

  descBlocks.forEach(function (block) {
    // Remove any stray <meta> tags accidentally pasted into the body (breaks bold/strong tags)
    block.querySelectorAll('meta').forEach(function (el) {
      el.remove();
    });

    // Unwrap Google Sheets / Docs paste wrapper spans, keeping their content and any bold/italic inside intact
    block.querySelectorAll('span[data-sheets-root], span[id^="docs-internal-guid"]').forEach(function (span) {
      const parent = span.parentNode;
      while (span.firstChild) {
        parent.insertBefore(span.firstChild, span);
      }
      parent.removeChild(span);
    });

    // Strip inline style attributes from every element inside the description
    // so nothing pasted can override the theme's font, size, or weight
    block.querySelectorAll('[style]').forEach(function (el) {
      el.removeAttribute('style');
    });
  });
});